import type { NavigateFunction } from 'react-router-dom';

/**
 * Destination for a transcription-exit navigation.
 *
 * - `item` — transcription has completed; navigate to the library item page.
 * - `job`  — transcription is still running; navigate to the job-progress page,
 *            which polls and auto-redirects to the library item on completion.
 */
export type TranscriptionDestination =
  | { kind: 'item'; itemId: string }
  | { kind: 'job'; jobId: string };

/**
 * Single entry point for leaving the transcription submission screen.
 *
 * Every completion / dispatch handler in `transcription-container.tsx` MUST
 * call this helper rather than invoking `navigate(...)` inline. Three
 * historical bugs in the same file (private-upload completion x2, URL-flow
 * non-cache-hit x1) came from a handler that set terminal state but forgot
 * to navigate. See SPEC_LESSONS L13 and
 * `docs/specs/2026-04-22-finalize-transcription-navigate.md`.
 */
export function finalizeTranscriptionAndNavigate(
  navigate: NavigateFunction,
  dest: TranscriptionDestination,
): void {
  if (dest.kind === 'item') {
    navigate(`/transcript/${dest.itemId}`);
    return;
  }
  navigate(`/transcription/${dest.jobId}`);
}
